//Libraries
import React, {useState, useEffect, Fragment} from 'react';
import { PDFViewer } from '@react-pdf/renderer';
import { useQuery, useQueryClient} from '@tanstack/react-query';
import { pdf } from "@react-pdf/renderer";
import Swal from "sweetalert2"
import { IoIosArrowDropdown, IoIosArrowDropup} from 'react-icons/io';
import { Client } from '@tanstack/react-query';
import {FiEdit, FiInfo} from 'react-icons/fi'
import { TbReportAnalytics } from "react-icons/tb";
import { infoAlert, isThereBase64, updateDevices, userLogCheck } from '../lib/utils';
import { v4 as uuidv4 } from 'uuid'; 
import ScanQrCode from '../components/ScanQrCode';
import {DevicePin, BottomMobileMenu, AddButton,TitleWithIcon, Loading, VisDiv, RegisterTable, SliderRegistri, Worksheet, OfflineUpdate, DesktopRegisterHeader, PdfRegistro, UserIcon, SiteInfo, RegisterInfo, FieldDropdown, CustomerLogo, CheckIcon} from '../components';
import { sortDevices, addValueForDropdown, registerCollections, floor, deviceInRegister, screenPosition as sPosition, successAlert, errorAlert, siteAddress, objectIsObject, unique, findKey, siteName, positionNumber, mergeZone, deviceAreas } from '../lib/utils'; 
import {templatesQuery, customerProductQuery, clientsQueryIndex, offersIndexQuery, clientOffersSiteIds, clientOrdersByClient, sitesQuery, registersQuery, nonConfQuery, subNonConformities, customerUsersQuery, contractorsUsersQuery, registersAsTemplatesQuery} from '../lib/data';
//Common Components
import { _FETCH } from '../lib/patches';
import { useStateContext } from '../context/StateContext';
import { useOfflineContext } from '../context/OfflineContext';
import { headerData, registerTableData } from '../lib/tableData'; 
import useMediaQuery from '../hooks/useMediaQuery'
import RegisterNonConformity  from '../components/frontend_components/RegisterNonConformity';
import {useAppend, useCreateReplace, useReplaceDevice} from '../hooks/mutations'
import AddNewDevice from './device';
import useNetworkStatus from '../hooks/useNetworkStatus';
import Selector from '../components/Selector';
import EditRegisters from '../components/EditRegisters';
import { facilityClient, clientUser } from '../lib/userPermissions';
import TrueFalseToggle from '../components/TrueFalseToggle';
import { useAuthContext } from '../hooks/useAuthContext';
import { referenceDoc } from '../components/gestioneDatabase/Docs';
import { urlFor } from '../lib/client';
import { HiddenOfferData } from '../components/offerComponents/HiddenOfferData';
import { postingEmail } from '../components/NodeMailer';
import TestButton from '../components/frontend_components/TestButton';
import isEqual from 'lodash/isEqual';
import { useDebounce } from '../hooks/useDebounce';

/**
 * #registersDevicesNonConformitiesModule
 * 
 * The Home component manages the UI and logic for the main page of the application.
 * It handles the state and interactions related to devices, registers, clients, and
 * sites. The component fetches data using react-query, manages user interactions, 
 * and provides options to view and edit registers and devices. It also includes
 * functionality to generate PDFs, toggle views, and handle offline data updates.
 * 
 * This component uses multiple contexts for managing state: StateContext, OfflineContext, 
 * and AuthContext. It also utilizes a variety of hooks for network status, media query 
 * handling, and data mutations.
 */

const Home = () => {
   

    // CONTEXTS AND HOOKS
    const { user } = useAuthContext()

    const {
        customer,
        client,
        setClient,
        site,
        setSite,
        register,
        setRegister,
        registerTemplates,
        setRegisterTemplates,
        currentTemplate,
        setCurrentTemplate,
        currentDevice,
        setCurrentDevice,
        devices,
        setDevices,
        setDeviceEdit,
        sUser,
        clients, 
        setClients,
        sites, 
        setSites,
        registers, 
        setRegisters,
        setSelectorVis,
        setNonConformities,
        nonConformities,
        setCustomerUsers,
        customerUsers,
        indexPage, 
        setIndexPage,
        loading, 
        setLoading,
        deviceNonConformities,
        setDeviceNonConformities,
        LDB,
        mobileView,
        setMobileView,
        screenPosition,
        setScreenPosition,
        setSubReasons,
        apiUrl,
        isWorksheet,
        setIsWorksheet,
        setDuplicateDevice,

    } = useStateContext();

    const {
        offlineData,
        failedDevicesQueryDocs,
        setOfflineData,
        bypassOffline,
        setFailedDevicesQueryDocs,
    } = useOfflineContext()
        
    //returns the current network status, used for offline mode
      const networkStatus = useNetworkStatus()
    //#registerTable
    const registerTableDoc = (devices) => ({
        devices, 
        registerTemplate: currentTemplate, 
        nonConformities, 
        deviceNonConformities, 
        LDB,
        client
    })

    //==============================================================================


    const [sortDevicesBy, setSortDevicesBy] = useState("Posizione")
    const [viewPdf, setViewPdf] = useState(false)
    const [editRegister, setEditRegister] = useState(false)
    const [viewInfo, setViewInfo] = useState(false)
    const [registerInfo, setRegisterInfo] = useState(false)
    const [selectedDevices, setSelectedDevices] = useState([])
    const [triggerSelectDevices, setTriggerSelectedRegisters] = useState(false)
    const [qrCheck, setQrCheck] = useState(false)
    
    const [registerDevices, setRegisterDevices] = useState(!Array.isArray(devices) ? [] : devices?.filter?.(device=>(device?.register?._ref===register?._id && device?.status !== "ARCHIVIATO" )))
    const [tableData, setTableData] = useState(registerTableData(registerTableDoc(registerDevices)) ? registerTableData(registerTableDoc(registerDevices)) : [])
    const [tab, setTab] = useState("REGISTER")
    const [viewArchivedDevices, setViewArchivedDevices] = useState(false)
    const [viewNonCheckedDevices, setViewNonCheckedDevices] = useState(false)
    const [viewAllDevices, setViewAllDevices] = useState(false)
    const [viewArchivedRegisters, setViewArchivedRegisters] = useState(false)
   
  
    //route to the backend
    const fetchRoute = `${apiUrl}/calls/fetch-docs`
    const testingFloor = false

    //check if there are devices that were not saved to the database and triggers the offline module #offlineUpdate
    const isThereFailedDevicesQueryDocs = () => {
        if(!failedDevicesQueryDocs) return false
        if(!Array.isArray(failedDevicesQueryDocs)) return false
        if(failedDevicesQueryDocs?.length < 1) return false
        return true
       
    }
    //only used to transfer devices from one register to another
    const triggerSelectDevicesFn = (data) => {
        setTriggerSelectedRegisters(data)
    } 
    // P is used for multi language capabilities
    const P = "index"

    //it closes all the info dropdowns
    const closeAllInfo = () => {
        setRegisterInfo(false)
        setViewInfo(false)
    }
    /**
     * Tests and logs floor values for a specific device across different register sources.
     *
     * @param {Object} options - The parameter object.
     * @param {string} [options.codeLocation=""] - Identifier for the code location triggering the test, used for logging.
     * @param {Array} options.registers - Array of register objects to search for the device.
     * @param {Array} options.registersData - Another array of register objects to search for the device.
     * @param {string} [options.deviceId="e0b89a5b-851c-45c7-ac24-6cc8e2d63846"] - The ID of the device to find and test.
     * @param {string} [options.registerId="qQNB1ZAgTG6nT9M7yCDtcz"] - The ID of the register to search within.
     */
    const testFloor = ({codeLocation="", registers, registersData, deviceId="e0b89a5b-851c-45c7-ac24-6cc8e2d63846", registerId="qQNB1ZAgTG6nT9M7yCDtcz" }) => {
        const registerInRegisters = !Array.isArray(registers) ? [] : registers?.find?.((x)=>x?._id == registerId)
        const registerInQuery = !Array.isArray(registersData) ? [] : registersData?.find?.((x)=>x?._id == registerId)        
        const currentMilliseconds = Date.now();
        testingFloor && console.log("floorInRegister", 
            `testFloor ${codeLocation}`,
            "mill", currentMilliseconds,  
            "floorInRegister", floor(deviceInRegister(deviceId, register)), 
            "floorRegisterInRegisters", floor(deviceInRegister(deviceId, registerInRegisters)), 
            "floorRegisterInQuery", floor(deviceInRegister("deviceId", registerInQuery))
        )

    }
    //sometimes the register disappears from the internal registers array, this is a simple check 
    const isRegisterInRegisters = !Array.isArray(registers) ? [] : registers?.some?.((x)=>x?._id == register?._id)

    
    /**
     * Finds and fixes duplicate keys in the devices array of the current register. It should not happen thanks to the useDebounce hook.
     * It checks for devices with the same _key and returns the first device with a qrUrl, 
     * or the first device if no devices have a qrUrl.
     * If there are more than two devices with the same _key, it returns the first device with a qrUrl.
     * If there are no devices with a qrUrl, it returns the first device.
     * If the two devices are equal, it returns the first device.
     * If the two devices are not equal, it returns the first device and logs an error.
     */
    const fixDuplicateKeys = () =>{
        
        const registerDevices = !Array.isArray(register?.devices) ? [] : register?.devices
        const devicesWithUniqueKeys = unique("_key", registerDevices)
        let errors = []
        const modifyUniqueDevices = devicesWithUniqueKeys?.map((item,index,array)=>{
            const foundDevices = registerDevices?.filter?.((x)=>x?._key == item?._key)
            if(foundDevices?.length == 2){
                    const firstDoc = foundDevices[0]
                    const secondDoc = foundDevices[1]
                    const areObjectsEqual = isEqual(firstDoc, secondDoc)
                    if(!areObjectsEqual) {
                        if(firstDoc?.qrUrl && !secondDoc?.qrUrl) {
                            return firstDoc
                        }
                        if(secondDoc?.qrUrl && !firstDoc?.qrUrl) {
                            return secondDoc
                        }
                        else {
                            //errors.push("not equal")
                            return firstDoc
                            return console.log("lqojdwqdj foundDevices are not equal", foundDevices)
                        }
                        
                    }
                    if(areObjectsEqual) return firstDoc
                
                }
            if(foundDevices?.length > 2) {
                const findOneWithQrUrl = !Array.isArray(foundDevices) ? undefined : foundDevices?.find?.((x)=>x?.qrUrl)
                if(findOneWithQrUrl) return findOneWithQrUrl
                return foundDevices[0]
            }
            return item
        })

        console.log("register lqojdwqdj", {register, devicesWithUniqueKeys, modifyUniqueDevices, registerDevices})
        if(errors?.length > 0) {
            console.log("lqojdwqdj found errors", errors)
            return
        }
        updateRegister({doc:{...objectIsObject(register), devices: modifyUniqueDevices}})

    }
    /**
     * Changes the userLog postedBy field of all devices in the current register from userToChangeRef to newUserRef. Done by the programmer 
     * on request from the admin to change the user for another user.-
     * Itcannot be changed with a "Cliente" user.
     * @param {string} userToChangeRef - The _ref of the user to change.
     * @param {string} newUserRef - The _ref of the new user.
     */
    const changeCheckUser = (userToChangeRef, newUserRef) => {
      
        const users = customerUsers?.filter?.((x)=>x?.userType !== "Cliente")

        const newRegister = {...register, devices: register?.devices?.map?.((device)=>({
            ...device,
            userLog: device?.userLog?.map?.((log)=>{
                if(log?.postedBy?._ref == userToChangeRef) {
                    console.log("Found log to change lkcjlskdcj", log)
                    return({...log, postedBy: referenceDoc(newUserRef)})
                }
                return log
            })


        }))}
          console.log("change check user", {register, users, newRegister})
          updateRegister({doc:newRegister})
    }

    const testFunction = async() => { 
            //console.log("fixing duplicate keys")      
            //fixDuplicateKeys()
            //changeCheckUser()
     }
    //current screen size
    const screenSizeDesktop = useMediaQuery("(min-width: 1600px)")

    /**
     * Return the assigned clients array from sUser if it exists and has a length > 0.
     * If it does not exist or has a length < 0 and the user type is "Cliente", return undefined.
     * In all other cases, return an empty array.
     * @returns {Array|undefined}
     */
    const assignedClients = () => {
        if(sUser?.assignedClients?.length>0) return sUser?.assignedClients
        if(sUser?.assignedClients?.length<0 && sUser?.userType == "Cliente") return undefined
        return []
    } 
    const assignedClientsIds = !Array.isArray(assignedClients()) ? [] : assignedClients()?.map?.((item)=>`"${item?._ref}"`)

    // use effect show or hide the visibility of the client/site selector
    useEffect(()=>{
        if(indexPage=="HOME"){
            if(!site)setSelectorVis(true)
            //console.log("POS", indexPage)
            window.scrollTo(0, screenPosition);
        }
    },[indexPage])

    const customerId = customer?._id ? customer?._id : sUser?.customer?._ref

//========================================= INITIAL LOAD, THE DATA IS SAVED IN FORAGE FOR OFFLINE USE. IT TURNS CACHE AND STALE TO INFINITY IF THERE IS OFFLINE DATA OR IF THE NETWORK IS OFFLINE =========================================================

    const {data: customersUsers, isLoading: customersUsersLoading} = useQuery(['customersUsers'], ()=> _FETCH({route: fetchRoute, user, query: customerUsersQuery(customerId)}),{
        onSuccess: (data)=>{ setCustomerUsers(data)},
        staleTime: (!networkStatus  || isThereFailedDevicesQueryDocs()) && Infinity,
        cacheTime: (!networkStatus  || isThereFailedDevicesQueryDocs()) && Infinity,
        onError:(error)=>{console.log("customersUsers not loaded", error)},
        enabled: !! customerId && !! sUser && !! user && !isThereFailedDevicesQueryDocs(),
    }) 
/*     const {data: testData, isLoading: testDataLoading} = useQuery(['testData'], ()=> _FETCH({route: fetchRoute, user, query: 
        `
        *[
        _type == "register" &&
        "2544eec9-f500-4a5a-9cbd-ab53c5ec5496" in devices[].nonConformities[]._id
        ]
             `
        }),{
        onSuccess: (data)=>{ console.log("test data loaded ldjqwidjqwoid", data)},
        enabled: true,
    })  */
    const {data: subReasonsData, isLoading: subReasonsLoadingData} = useQuery(['subReasons'], ()=> _FETCH({route: fetchRoute, user, query:'*[_type == "list" && _id == "5fabe5aa-8b2b-4bb8-b232-c51ba64fa221"  ]{...,"fieldList":fieldList[]->}'}),{
        onSuccess: (data)=>{ setSubReasons(addValueForDropdown(data[0]?.fieldList))},
        staleTime: (!networkStatus  || isThereFailedDevicesQueryDocs()) && Infinity,
        cacheTime: (!networkStatus  || isThereFailedDevicesQueryDocs()) && Infinity,
        onError:(error)=>{console.log("subReasons", error)},
        enabled: !! customerId && !! sUser  && !! user && !isThereFailedDevicesQueryDocs(),
      })

    const customerTemplateIds = !Array.isArray(customer?.registerTemplates) ? [] : customer?.registerTemplates?.map?.((item)=>{
        return (`"${item?._ref}"`)
        })
    const {data: templatesData, isLoading: templatesDataLoading} = useQuery(['templates'], ()=>_FETCH({route: fetchRoute, user, query: templatesQuery(customerTemplateIds)}),{
        enabled: !! customerId && !! sUser && !! user && !isThereFailedDevicesQueryDocs(),
        staleTime: (!networkStatus  || isThereFailedDevicesQueryDocs()) && Infinity,
        cacheTime: (!networkStatus  || isThereFailedDevicesQueryDocs()) && Infinity,
        onSuccess: (data)=>{
            setRegisterTemplates(data)
            const findCurrentTemplate = !Array.isArray(data) ? undefined : data?.find?.((template)=>template?._id == currentTemplate?._id)
            if(currentTemplate && findCurrentTemplate) {
                setCurrentTemplate(findCurrentTemplate)
            }
            //console.log("templates loaded iuwejdiweuhd", {data, currentTemplate, findCurrentTemplate});
        },
        onError:(error)=>{console.log("templates not loaded", error)},
    })

    const {data: nonConformitiesData, isLoading: nonConformitiesLoading} = useQuery(['nonConformities'], ()=>_FETCH({route: fetchRoute, user, query: nonConfQuery(customerTemplateIds)}),{
        enabled: !! customerId && !! sUser  && !! user && !isThereFailedDevicesQueryDocs(),
        staleTime: (!networkStatus  || isThereFailedDevicesQueryDocs()) && Infinity,
        cacheTime: (!networkStatus  || isThereFailedDevicesQueryDocs()) && Infinity,
        onSuccess: (data)=>{
            //console.log("nonConformities loaded", data);
            setNonConformities(data);   
        },
        onError:(error)=>{console.log("nonConformities not loaded", error)},
    })
        const {data: customerProductsData, isLoading: customerProductsLoading} = useQuery(['customerProducts'], ()=> _FETCH({route: fetchRoute, user, query: customerProductQuery()}),{
        enabled: !! customerId && !! sUser  && !! user && !isThereFailedDevicesQueryDocs(),
        staleTime: (!networkStatus  || isThereFailedDevicesQueryDocs()) && Infinity,
        cacheTime: (!networkStatus  || isThereFailedDevicesQueryDocs()) && Infinity,
        onSuccess: (data)=>{
            //console.log("customer products loaded", data);
           
        },
        onError:(error)=>{console.log("nonConformities not loaded", error)},
          })
    const {data: subNonConformitiesData, isLoading: subNonConformitiesLoading} = useQuery(['subNonConformities'], ()=>_FETCH({route: fetchRoute, user, query: subNonConformities()}),{
        enabled: !! customerId && !! sUser  && !! user && !isThereFailedDevicesQueryDocs(),
        staleTime: (!networkStatus  || isThereFailedDevicesQueryDocs()) && Infinity,
        cacheTime: (!networkStatus  || isThereFailedDevicesQueryDocs()) && Infinity,
        onSuccess: (data)=>{
            //console.log("subNonConformities loaded", data);
            //setNonConformities(data);   
        },
        onError:(error)=>{console.log("nonConformities not loaded", error)},
    })


    //======== REGISTERS AS TEMPLATES========

    // React Query hook
    const { data: registersAsTemplates, isLoading: registersAsTemplatesLoading,} = useQuery(
    ['registersAsTemplates', customer?._id], // cache key
    () => _FETCH({ 
        route: fetchRoute, 
        user, 
        query: registersAsTemplatesQuery(customer?._id) 
    }),
    {
        enabled: !!customer?._id && !!user,
        onSuccess: (data) => {
        //console.log(' mdòlqwmdòlqwmd registersAsTemplates loaded:', data);
        // Example: set to state if needed
        // setRegisters(data);
        },
        onError: (error) => {
        console.error('Failed to load registersAsTemplates:', error);
        },
        staleTime: (!networkStatus || isThereFailedDevicesQueryDocs()) && Infinity,
        cacheTime: (!networkStatus || isThereFailedDevicesQueryDocs()) && Infinity,
    }
    );

    const {data: clientsData, isLoading: clientsDataLoading} = useQuery(['clients', customer, sUser], ()=>_FETCH({route: fetchRoute, user, query: clientsQueryIndex(customerId, assignedClientsIds, sUser)}),{
        enabled: !! customerId && !! sUser  && !! user && !isThereFailedDevicesQueryDocs(),
        refetchOnWindowFocus: false,
        onSuccess: (data)=>{
            //if(!sUser) return
            if(sUser.userType == "Cliente") {
   
                if(assignedClientsIds < 1) {
                    console.log("Cliente null")
                    return
                }
                else {
                    if (data.length == 1) {
                        console.log("Cliente 1")
                        //console.log("single client set")
                        setClients(data)
                        setClient(data[0])
                        return
                    }
                    console.log("Cliente null")
                    setClients(data)
                    return
                }
            }
            //console.log("clients loaded", clientsData) 
            if (data.length == 1) {
                console.log("single client set")
                setClient(data[0])
            }
            setClients(data)
        },
        staleTime: (!networkStatus  || isThereFailedDevicesQueryDocs()) && Infinity,
        cacheTime: (!networkStatus  || isThereFailedDevicesQueryDocs()) && Infinity,

        //staleTime: 1000 * 60 * 60,
        onError:(error)=>{
            console.log("clients not loaded", error)
        },
    }) 

    const contractorsIds = !Array.isArray(client?.contractors) ? [] : client?.contractors?.map?.((item)=> `"${item?._ref}"`)
    
   //  ===================== LOAD AFTER CLIENT IS SELECTED ========================

   const {data: contractorsUsers, isLoading: contractorsUsersLoading} = useQuery(['contractorsUsers'], ()=> _FETCH({route: fetchRoute, user, query: contractorsUsersQuery(contractorsIds)}),{
    onSuccess: (data)=>{ setCustomerUsers([...!Array.isArray(customerUsers) ? [] : customerUsers, ...!Array.isArray(data) ? [] : data])},
    staleTime: (!networkStatus  || isThereFailedDevicesQueryDocs()) && Infinity,
    cacheTime: (!networkStatus  || isThereFailedDevicesQueryDocs()) && Infinity,
    onError:(error)=>{console.log("customersUsers not loaded", error)},
    enabled:  !! contractorsIds?.length>0 && !! sUser && !! user && !isThereFailedDevicesQueryDocs(),
})
     const {data: presidioModulesData, isLoading: presidioModulesLoading} = useQuery(['presidioModules'], ()=> _FETCH({route: fetchRoute, user, query: '*[_type == "presidioModule"]'}),{
       onError:(error)=>{console.log("nonConformities", error)},
      // enabled: isLoaded,
       //staleTime: 1000 * 60 * 60,
     })
   
    const {data: sitesData, isLoading: sitesDataLoading} = useQuery([['sites'], client], ()=>_FETCH({route: fetchRoute, user, query: sitesQuery(client._id)}),{
        enabled: !! client && !! sUser && !! user && !isThereFailedDevicesQueryDocs(),
        onSuccess: (data)=>{
            //console.log("sites loaded")
            if (data?.length == 1) {  
                setSite({...data[0], label: siteName(data[0]), value: siteName(data[0])})
            }
            setSites(data)},
        //staleTime: 1000 * 60 * 60,
        staleTime: (!networkStatus  || isThereFailedDevicesQueryDocs()) && Infinity,
        cacheTime: (!networkStatus  || isThereFailedDevicesQueryDocs()) && Infinity,
        onError:(error)=>{console.log("sites not loaded", error)},
    }) 
    const {data: registersData, isLoading: registersDataLoading, refetch} = useQuery(['registers', site], ()=>_FETCH({route: fetchRoute, user, query: registersQuery(site._id)}),{
        enabled: !! site && !! sUser && !! user && !isThereFailedDevicesQueryDocs(),
        staleTime: (!networkStatus  || isThereFailedDevicesQueryDocs()) && Infinity,
        cacheTime: (!networkStatus  || isThereFailedDevicesQueryDocs()) && Infinity,
        onSuccess: (data)=>{
                //testFloor({codeLocation:"inRegistersDataQuery", register, registers, registersData: data})
                setRegisters(data);
        },
        onError:(error)=>{console.log("registers not loaded", error)},
        //refetchOnWindowFocus: true, // Prevent refetch on window focus
        //refetchOnMount: true // Prevent refetch on component mount
    })

    //===================================================#worksheet #unused ========================================================
    //THIS DATA WAS LOADED FOR THE ORDER AND FOGLIO DI LAVORO; THESE MODULES WERE SCRAPPED AS UNTESTED
    const offersData = []
/*     const {data: offersData, isLoading: offersDataLoading} = useQuery(['offers', site], ()=>_FETCH({route: fetchRoute, user, query: offersIndexQuery(site?._id)}),{
        enabled: !! site && !isThereFailedDevicesQueryDocs(),
        refetchOnWindowFocus: false,
        staleTime: (!networkStatus  || isThereFailedDevicesQueryDocs()) && Infinity,
        cacheTime: (!networkStatus  || isThereFailedDevicesQueryDocs()) && Infinity,
        onError:(error)=>{console.log("offers data not loaded", error)},
        onSuccess: (data)=>{
            //testFloor({codeLocation:"inRegistersDataQuery", register, registers, registersData: data})
            //setRegisters(data);
            //console.log("offers data loaded", data)
    },
    }) */
      const clientOrdersData = []
    //clientOffersSiteIds
    //const offersIds = !Array.isArray(offersData) ? [] : offersData?.map?.((item)=> `"${item?.offerId}"`)
/*     const {data: clientOrdersData, isLoading: clientOrdersDataLoading} = useQuery(['clientOrders', client], ()=> _FETCH({route: fetchRoute, user, query: clientOrdersByClient(client?._id)}),{
        enabled: !! client && !isThereFailedDevicesQueryDocs(),
        staleTime: (!networkStatus  || isThereFailedDevicesQueryDocs()) && Infinity,
        cacheTime: (!networkStatus  || isThereFailedDevicesQueryDocs()) && Infinity,
        onSuccess: (data)=>{
            //testFloor({codeLocation:"inRegistersDataQuery", register, registers, registersData: data})
            //setRegisters(data);
            //console.log("Orders data loaded", data)
    },
        onError:(error)=>{console.log("clientOrdersData", error)},
        //staleTime: 1000 * 60 * 60,
        }) */


        const orderOptions = !Array.isArray(clientOrdersData) ? [] : clientOrdersData?.map?.((item)=>({...item, value: item?.label}))
        const [registerClientOrder, setRegisterClientOrder] = useState(orderOptions[0])
        const orderedOffer = !Array.isArray(offersData) ? undefined : offersData?.find?.(x=>x?.offerId == registerClientOrder?.offerId)
        const orderedOfferFields = !Array.isArray(orderedOffer?.offerFields) ? [] : HiddenOfferData(
            {
                offerData: orderedOffer?.offerFields, 
                allOffers: offersData
            }
        )?.filter(x=>!x?.hide)?.filter?.((x)=>x?.clientOrder?._ref === registerClientOrder?._id)

        const orderedRegisters = unique("registerId", orderedOfferFields?.filter?.((x)=>!x?.labourProduct))?.map?.((x)=>x?.registerId)
        const orderedDevices = unique("deviceId", orderedOfferFields)?.filter?.((x)=>!x?.labourProduct)?.map?.((x)=>x?.deviceId)

        const offersDataSiteIds = []
/*         const {data: offersDataSiteIds, isLoading: offersDataDataIdsLoading} = useQuery(['offersSiteIds', client, registerClientOrder], ()=>_FETCH({route: fetchRoute, user, query: clientOffersSiteIds(client?._id, registerClientOrder?._id)}),{
            enabled: !! client && !!registerClientOrder && !isThereFailedDevicesQueryDocs(),
            refetchOnWindowFocus: false,
            staleTime: (!networkStatus  || isThereFailedDevicesQueryDocs()) && Infinity,
            cacheTime: (!networkStatus  || isThereFailedDevicesQueryDocs()) && Infinity,
            onError:(error)=>{console.log("offers data not loaded", error)},
            onSuccess: (data)=>{
                //testFloor({codeLocation:"inRegistersDataQuery", register, registers, registersData: data})
                //setRegisters(data);
                //console.log("offers data Ids loaded", data)
        },
        }) */
        //const orderedOffers = offersData?.find?.(x=>x?.offerId == registerClientOrder?.offerId)
        const orderedSites = !Array.isArray(offersDataSiteIds) ? [] : unique("siteId", offersDataSiteIds)?.map?.((x)=>x?.siteId)

/*         useEffect(()=>{
            setRegisterClientOrder(orderOptions[0])
        },[client, clientOrdersData]) */

        //======================================================================================================


        // when registers change, reloads the collections with all the devices and non conformities
        useEffect(() => {

            if (!registers?.length) return;
/*             if(failedDevicesQueryDocs?.length > 0){
                return
            } */
            testFloor({codeLocation:"oijoij", register, registers, registersData})
            const start = Date.now();
            setLoading(true);
            
            try {
                const collections = registerCollections(registers, isWorksheet);
                //console.log("qà4fkjàq3k")
                // Batch state updates in a single React render cycle
                if (collections?.devices || collections?.nonConformities) {
                    const batchUpdate = () => {
                        if (collections?.devices) {
                            setDevices(collections.devices);
                        }
                        if (collections?.nonConformities) {
                            setDeviceNonConformities(collections.nonConformities);
                        }
                    };
                    // Use React's batching
                    batchUpdate();
                }
            } catch (err) {
                console.error('Error processing registers:', err);
                toast.error('Error processing registers. Please refresh the page.');
            } finally {
                setLoading(false);
                //console.log("Register processing completed in", Date.now() - start, "ms");
            }
        }, [registers, currentTemplate, isWorksheet]);

    const queryClient = useQueryClient()



    // =================================================================== MUTATIONS #mutations =================================================== 

    
    /**
     * Offline function to update the device in the registers array. it updates the forage data to match the changes in the database, and then 
     * uses this data in case of failure to update the database
     * 
     * @param {Object} queryDoc - The document to be updated
     * @param {Array} registers - The array of registers
     * @param {boolean} byPassSetOffline - If true, the function will not update the failedDevicesQueryDocs state
     * @returns {Object} The updated register
     * @throws {Error} If the update fails
     */
    const offlineFn = (queryDoc, registers, byPassSetOffline) => {
    //console.log(JSON.stringify({test: 1, index: "dmqowdkj"}))
    const start = Date.now();
    
    try {
        const doc = queryDoc?.doc;
        const registerId = register?._id ;
        const queryRegisterId = queryDoc?.id || queryDoc?.documentId
        
        // Input validation
        if (!doc) {
            throw new Error(`Non c'è il documento in queryDoc` );
        }
        if (!Array.isArray(registers) || !registers?.length) {
            throw new Error('Non ci sono registri caricati. Ricarica la pagina' );
        }
        if (!register) {
            throw new Error(`Non c'è un registro selezionato. Seleziona il registro` );
        }
        if(doc?._id == "e0b89a5b-851c-45c7-ac24-6cc8e2d63846"){
            throw new Error('Custom error for POLVERE ABC POS 1 EST DEMO' );
        }
        
        if (!registerId) {
            throw new Error('Il registro non ha un _id' );
        }
        if(queryRegisterId !== register?._id){
            throw new Error('Il registro non corrisponde al registro selezionato', queryDoc?.id );
        }
        // Update registers array efficiently using map
        const updatedRegisters = !Array.isArray(registers) ? [] : registers.map?.(reg => {
            if (reg?._id !== registerId) return reg;
            
            // Update devices array with minimal spread operations
            return {
                ...objectIsObject(reg),
                devices: [
                    ...!Array.isArray(reg?.devices) ? [] : reg?.devices?.filter?.(device => device?._id !== doc?._id),
                    doc
                ]
            };
        });

        // Find updated register for state updates
        const updatedRegister = !Array.isArray(updatedRegisters) ? undefined : updatedRegisters.find?.(r => r._id === registerId);
        
        if (!updatedRegister) {
            console.error('jkdsqidjoiwq', {updatedRegister, updatedRegisters, registerId, registers } );
            throw new Error('Register not found after update');
        }

        // Batch state updates in a single render cycle
        const batchUpdate = () => {
            setRegisters(updatedRegisters);
            setRegister(updatedRegister);
            setCurrentDevice(doc);
        };
        batchUpdate();
        if(!byPassSetOffline){
            //setOfflineData([...!Array.isArray(offlineData) ? [] : offlineData?.filter((x) => x?._id !== updatedRegister?._id), updatedRegister]);
            console.log("setFailedDevicesQueryDocs in offlineFn oioqwijdiowqdj ", {failedDevicesQueryDocs, doc, queryRegisterId})
            setFailedDevicesQueryDocs([...!Array.isArray(failedDevicesQueryDocs) ? [] : failedDevicesQueryDocs?.filter((x) => x?._id !== doc?._id), {...doc, register: referenceDoc(queryRegisterId)}])
        }

        // Execute custom function if provided
        queryDoc?.customFn?.();

        console.log("Device update completed in", Date.now() - start, "ms");
        return updatedRegister;

    } catch (err) {
        const errorToEmail = {
            internalErrorId: "qpwekqpwoek",
            functionName: "offlineFn",
            page: "index.js",
            err: err,
            subject: `${err?.message} - ${sUser?.lastName}`,
            message: err?.message,
            registersCount: registers?.length,
            timeTaken: Date.now() - start,
            user: sUser?.lastName,
            networkStatus,
            queryDoc: queryDoc,  
        };
        console.error('Offline function failed qpwekqpwoek:', errorToEmail);
        errorAlert(`Non è stato possibile salvare il dispositivo: qpwekqpwoek ${err?.message}`, errorToEmail);
        throw (errorToEmail);
    }
};
    //This function is used to replace a device inside the devices array, it doesn't change the whole register
    const {mutate: replaceDevice} = useReplaceDevice({
        onMutate: async (newDoc) => {
            await queryClient.cancelQueries({ queryKey: ['registers', site] })
            //const previousRegisters = queryClient.getQueryData(['registers', site])
    
            queryClient.setQueryData(['registers', site], (old) => { 
                //const oldData = old?.length > 0 ? old : registers
                console.log("Replace device doc òqwlkeòqlwkeòqwl", {newDoc, registers, registers, old})
                const updatedRegister = offlineFn(newDoc, registers, true)
                const updatedRegisters = !updatedRegister ? registers : [...registers?.filter((x) => x?._id !== updatedRegister?._id), updatedRegister]

                return updatedRegisters// Now returns array directly
            })
            setLoading(false)
            

            return { registers, device: currentDevice, register }
        },
        onSuccess: (data, variables) => {
            //queryClient.invalidateQueries(['registers', site]);
            const base64Present = isThereBase64(data)
            console.log("SUCCESS!!!!! setFailedDevicesQueryDocs", {data, failedDevicesQueryDocs, variables, base64Present})
            if(base64Present){
                setFailedDevicesQueryDocs([...!Array.isArray(failedDevicesQueryDocs) ? [] : failedDevicesQueryDocs?.filter((x) => x?._id !== variables?.doc?._id), variables?.doc])
            }
            else{
                const isThereOfflineDevice = failedDevicesQueryDocs?.some((x) => x?._id == variables?.doc?._id)
                if(isThereOfflineDevice){
                setFailedDevicesQueryDocs([...!Array.isArray(failedDevicesQueryDocs) ? [] : failedDevicesQueryDocs?.filter((x) => x?._id !== variables?.doc?._id)])
                successAlert("Presidio aggiornato in Offline")
                }
            }
            //successAlert("Presidio aggiornato")
        },
        onError: async(err, newDoc, context) => {

            const errorToEmail = {
                internalErrorId: "qklweqlkej",
                functionName: "replaceDevice",
                page: "index.js",
                err: err,
                subject: `${err?.message} - ${sUser?.lastName}`,
                message: err?.message,
                registersCount: registers?.length,
                user: sUser?.lastName,
                networkStatus,
                queryDoc: newDoc,  
            }; 
            
            console.error('replaceDevice and setFailedDevicesQueryDocs Update failed: qklweqlkej', {errorToEmail, err, newDoc, failedDevicesQueryDocs} )
            
            // Check if this is an offline function error (which should be handled differently)
            if(err?.internalErrorId == "qpwekqpwoek" ){
                console.log('Skipping because this is an offline function error');
                return
            }
            
            console.log('About to execute setFailedDevicesQueryDocs and infoAlert');
            //If there is an error, it adds the failed device to the offline array
            setFailedDevicesQueryDocs([...!Array.isArray(failedDevicesQueryDocs) ? [] : failedDevicesQueryDocs?.filter((x) => x?._id !== newDoc?.doc?._id), newDoc?.doc])
            infoAlert(`Salvato Offline`)

            console.log('Successfully executed setFailedDevicesQueryDocs and infoAlert');
            //queryClient.setQueryData(['registers', site], context?.registers)
            //setRegisters(context.registers)
            //setRegister(context.register)
            //updateDevices(devices, setDevices, currentDevice, context?.device)


        },
    })

    // Add throttling to prevent duplicate replaceDevice calls
    const [throttledReplaceDevice] = useDebounce(replaceDevice, 1000); // 1 second throttle
    // This function is used to replace the whole register
    const {mutate: updateRegister} = useCreateReplace({
        onMutate: async (newDoc) => {

            await queryClient.cancelQueries({ queryKey: ['registers', site] })
            const previousRegisters = queryClient.getQueryData(['registers', site])
        
            //const doc = newDoc?.doc
            
            queryClient.setQueryData(['registers', site], (old) => { 
                const oldData = registers
                const newData = [...!Array.isArray(oldData) ? [] : oldData?.filter?.(x=> x?._id !== newDoc?.doc?._id), newDoc?.doc]
                setRegisters(newData)
                setRegister(newDoc?.doc)
                //console.log("data", newData,"newDoc", newDoc)
                return newData // Now returns array directly
            })
            return { previousRegisters, device: currentDevice, register}
        },
        onSuccess: () => {
            console.log("Document Updated with duplication");
            // queryClient.invalidateQueries(['registers', site]);
            setSelectedDevices([])
            setDuplicateDevice(false);
            setDeviceEdit(false);
            setIndexPage("HOME");
        },
        onError:()=> {errorAlert("Errore: il registro non é stato aggiornato")}
    })


    //===================================== ARCHIVE REGISTERS ===================================
    
    const archiveRegister = () => {

        const alert = () => {
            Swal.fire({
                title: 'Archiviare il registro?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sì, Archivia Registro!',
                cancelButtonText: 'No'
              }).then((result) => {
                if (result.isConfirmed) {
                  //console.log("annullato!") 
                  const registerCopy = {...objectIsObject(register)}
                  delete registerCopy.order
                  updateRegister({doc:{...objectIsObject(registerCopy), status:"ARCHIVIATO"}})
                  //archiveDeviceAndNonConformities()
                  setRegister(undefined)
                  closeAllInfo()
                  setCurrentTemplate(undefined)
                  window.location.reload(true);

                } else {
                    errorAlert("ARCHIVIAZIONE NON RIUSCITA, RIPROVARE")
                }
              })
        }
      
        alert()  
     }

   const isThereArchivedDevices = !Array.isArray(devices) ? false : !!devices?.filter?.(device=>device?.register?._ref===register?._id && device?.status == "ARCHIVIATO")?.length > 0
  
   // ============================================ LOGS =================================================
    

    useEffect(()=>{
        testFloor({codeLocation:"ooijo", register, registers, registersData})
        const filteredDevices = !Array.isArray(devices) ? [] : devices
            ?.filter?.(device=>{
                if(viewArchivedDevices) return (device?.register?._ref === register?._id && device?.status == "ARCHIVIATO")
                return (device?.register?._ref===register?._id && device?.status !== "ARCHIVIATO")
            })
            ?.filter((x)=>{
                if(!viewNonCheckedDevices) return x
                const lastCheckDate = userLogCheck(x)?.date
                if(lastCheckDate) {
                    //#doneCheck
                    const now = Date.now()
                    const passedMills = now - lastCheckDate
                    const checkResetDays = register?.checkResetDays ? register?.checkResetDays : 120
                    const nMonths = 1000 * 60 * 60 * 24 * checkResetDays
                    if(passedMills < nMonths){return }
                    return x  
                }
                return x
            })
/*         if(failedDevicesQueryDocs?.length > 0){
            return
        } */
        //console.log("ijòoijòoij")
        if(devices){
            if(devices[0]?._id == devices[0]?._id){
                setLoading(true)
                setRegisterDevices(filteredDevices)
                setTableData(registerTableData(registerTableDoc(filteredDevices)))
                setLoading(false)
                } else {
                setLoading(true)
                //console.log ("query")
                setRegisterDevices(filteredDevices)
                setTableData(registerTableData(registerTableDoc(filteredDevices)))
                setCurrentDevice(currentDevice)
                setLoading(false)
                } 
        } else {
            setLoading(true)
            //console.log ("query else")
            setRegisterDevices(filteredDevices)
            setTableData(registerTableData(registerTableDoc(filteredDevices)))
            setLoading(false)
        }

    },[register, site, currentDevice, currentTemplate, devices, deviceNonConformities, viewArchivedDevices, viewNonCheckedDevices]) 
    
     const userLogs = !Array.isArray(registerDevices) ? [] : registerDevices?.map?.((item)=>item?.userLog ? item.userLog : []).flat(1).filter?.(x=>x.logType == "check").sort(function(a, b){return b.date - a.date})

     const lastLog = () => { 

        const log = userLogs?.length > 0 ? userLogs[0] : {}
        const logRef = log?.postedBy?._ref
        
        const postedBy = !Array.isArray(customerUsers) ? [] : (!Array.isArray(customerUsers) ? undefined : customerUsers?.find?.(x=>x?._id == logRef))
        //console.log("LAST LOGS:", postedBy)
        const newLog = {
            ...objectIsObject(log),
            postedBy
        }
        if(userLogs?.length<=0) return undefined
        if(logRef) return newLog
        return log }

  // ================================================== ADD NEW DEVICE ===========================================
    function addNewDevice (e) {
        
        if(!register?._id){
            e.stopPropagation();
            errorAlert("REGISTRO SELEZIONATO NON TROVATO, RICARICA E RIPROVA")
        }
        else if(!site?._id){
            e.stopPropagation();
            errorAlert("PLESSO SELEZIONATO NON TROVATO, RICARICA IL PLESSO E RIPROVA")
        }
        else {
            e.stopPropagation();
            setScreenPosition(sPosition())
            setCurrentDevice(undefined)
            setDeviceEdit(true)
            setIndexPage("DEVICE")
        }
    }
  // ================================================== PDF #pdfRegister ===========================================

  const headerDataPdf = headerData(customer,client,site,currentTemplate,register, lastLog(), LDB)
  const pdfTitle = headerDataPdf.site + "-" + headerDataPdf.register + ".pdf"
    const generatePdf = async () => {
        if (!headerDataPdf || !tableData || !tableData.data || tableData.data.length === 0) {
            errorAlert("Dati insufficienti per generare il PDF");
            return;
        }

        try {
            setLoading(true);

            const doc = (
                <PdfRegistro 
                    key={`${register?._id}-${Date.now()}`}
                    headerData={headerDataPdf} 
                    tableData={tableData}
                />
            );

            const blob = await pdf(doc).toBlob();
            if (!blob) {
                throw new Error('Generazione PDF fallita');
            }

            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = pdfTitle;
            
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Errore PDF:', error);
            errorAlert("Errore nella generazione del PDF. Riprova più tardi.");
        } finally {
            setLoading(false);
        }
    };

    const pdfButton = (
        <VisDiv rules={[headerDataPdf, tableData]}>
            {headerDataPdf && tableData && tableData.data && tableData.data.length > 0 && (
                <button 
                    className="pdf-button"
                    onClick={generatePdf}
                >
                    {LDB("misc","downloadPdf")}
                </button>
            )}
        </VisDiv>
    );
    
    const pdfViewer =   <PDFViewer style={{width:"100%", height: window.innerHeight - 200, marginTop:"20px"}}>
                            <PdfRegistro LDB={LDB} headerData={headerDataPdf} tableData={tableData}/>
                        </PDFViewer>
     
     // ================================================== WORKSHEET AND REGISTER MANAGEMENT #unused ===========================================

    const NONCONF_REGISTRO = <RegisterNonConformity registerTemplate={currentTemplate} register={register} setRegister={setRegister}/>
    
     const clickWorksheet = () =>{
        setTab("WORKSHEET")
        setIsWorksheet(true)
        //console.log("WORKSHEET")
    }

    const clickRegister = () =>{
        setTab("REGISTER")
        setIsWorksheet(false)
        //console.log("REGISTER")
    }

    //================================================================== SCROLL AND TOGGLES ===========================================

    const scrollToBottom = () => {
        //console.log("SCROLL TO BOTTOM")
        window.scrollTo({
            top: document.documentElement.scrollHeight,
            behavior: 'smooth',
          });
    }
        const scrollToTop = () => {
        //console.log("SCROLL TO BOTTOM")
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
    }

    const editingToggle = () => {
        //console.log("EDIT BUTTON")
        setEditRegister(!editRegister)
    }
    const infoToggle = () => {
        setViewInfo(!viewInfo)
    }
    const registerInfoToggle = () => {
        setRegisterInfo(!registerInfo)
        console.log("REGISTER INFO")
    } 
    //================================================= QR CODE SCANNER ===================================================
    
    const setQrDevice = (device) => {
        setScreenPosition(sPosition())
        setDeviceEdit(false)
        setDuplicateDevice(false)
        setCurrentDevice(device)
        setQrCheck(true)
        setIndexPage("DEVICE");
        scroll(0,0) 
        console.log("DEVICE TROVATO", device)
    }
    
    const saveQrCode = (data) => {
        const scannedQrUrl = data?.[0]?.rawValue
        if(!scannedQrUrl) { 
            errorAlert("QR CODE URL NON TROVATA")
            return }
       
        const findDevice = (register) => !Array.isArray(register?.devices) ? undefined : register?.devices?.find?.((x)=>x?.qrUrl == scannedQrUrl)
    
        if(findDevice(register)){
            console.log("FOUND QR CODE IN CURRENT REGISTER qwjdoqiwjdoi", {data, scannedQrUrl, findDevice: findDevice(register) })
            setQrDevice(findDevice(register))
            return
        }
        const findDeviceInOtherRegisters = !Array.isArray(registers) ? undefined : registers?.find?.((x)=>!Array.isArray(x?.devices) ? false : x?.devices?.some?.((y)=>y?.qrUrl == scannedQrUrl))
        if(findDeviceInOtherRegisters && findDevice(findDeviceInOtherRegisters)){
            const registerTemplate = !Array.isArray(registerTemplates) ? undefined : registerTemplates?.find?.((x)=>x?._id == findDeviceInOtherRegisters?.template?._ref)
            setRegister(findDeviceInOtherRegisters)
            setCurrentTemplate(registerTemplate)
            setQrDevice(findDevice(findDeviceInOtherRegisters))
            console.log("SAVE QR CODE IN OTHER REGISTER òoirhfòqioufh", {data, scannedQrUrl, findDeviceInOtherRegisters, findDevice: findDevice(findDeviceInOtherRegisters) })
            return
        }
        const findDeviceInOtherSites = !Array.isArray(sites) ? {} : sites?.find?.((x)=> !Array.isArray(x?.registers) ? false : x?.registers?.some?.((y)=>!Array.isArray(y?.devices) ? false : y?.devices?.some?.((z)=>z?.qrUrl == scannedQrUrl)))
        const findRegisterInSite = !Array.isArray(findDeviceInOtherSites?.registers) ? undefined : findDeviceInOtherSites?.registers?.find?.((x)=>!Array.isArray(x?.devices) ? false : x?.devices?.some?.((y)=>y?.qrUrl == scannedQrUrl))
        console.log("SAVE QR CODE IN OTHER SITE", {data, scannedQrUrl, findDeviceInOtherSites, findRegisterInSite, findDevice: findDevice(findRegisterInSite) })
        if(findDeviceInOtherSites?._id && findRegisterInSite && findDevice(findRegisterInSite)){
            const registerTemplate = !Array.isArray(registerTemplates) ? undefined : registerTemplates?.find?.((x)=>x?._id == findRegisterInSite?.template?._ref)
            setSite({...findDeviceInOtherSites, label: siteName(findDeviceInOtherSites), value: siteName(findDeviceInOtherSites)})
            setRegister(findRegisterInSite)
            setCurrentTemplate(registerTemplate)
            setQrDevice(findDevice(findRegisterInSite))

            return
        }
        _FETCH({
            route: fetchRoute,
            //route: scannedQrUrl,
            user: user,
            query: `*[_type == "register" && "${scannedQrUrl}" in devices[].qrUrl]{
                ...,
                site->{
                    ...,
                    client->{
                        ...,
                        customer->,
                        
                        }
                    },
            }`,
            
            onSuccess: (data) => {
                console.log("RECIEVED DATA FROM SERVER", {data})
                if(Array.isArray(data) && data.length === 0){
                    errorAlert("NON CI SONO PRESIDI CON QUESTO QR CODE ASSEGNATO")
                    return
                }
                const foundRegister = data[0]
                const newClient = foundRegister?.site?.client
                const newCustomer = foundRegister?.site?.client?.customer
                const newSite = foundRegister?.site
                const registerTemplate = !Array.isArray(registerTemplates) ? undefined : registerTemplates?.find?.((x)=>x?._id == foundRegister?.template?._ref)
                const newQrDevice = findDevice(foundRegister)
                const devicePosition = positionNumber(newQrDevice);
                const deviceFloor = floor(newQrDevice)
                const deviceArea = deviceAreas(newQrDevice) 
                
                const swalTitle = () => {
                    if(newClient?._id == client?._id && newSite?._id !== site?._id)return "plesso"
                    if(newClient?._id !== client?._id && newSite?._id !== site?._id)return "cliente e plesso"
                    return "plesso/cliente"
                }
                const registerName = `${foundRegister?.label} ${foundRegister?.registerName || ""}`
                const logo = () => {
                    if(!newCustomer?.logoHeader) return ""
                    return `                    
                    <div style="margin-bottom: 20px ">
                        <img style="width:${newCustomer?.logoHeaderSize?.width}px; height:${newCustomer?.logoHeaderSize?.height}px" src="${newCustomer?.logoHeader && urlFor(newCustomer?.logoHeader)?.url()}" alt="logo"/>
                    </div>`
                }

                const infoLine = ({value, title}) => {
                    if(!value) return ""
                    return `
                     <div style="display: flex">
                        <p><strong>${title}:</strong> ${value}</p>
                    </div>
                    `
                }
                console.log("RECEIVING DATA FROM QR FETCH", {deviceArea, newCustomer, data, scannedQrUrl, newQrDevice, registerTemplate, newSite, newClient, foundRegister})

                const htmlData = `
                <div style="text-align: center; border: 1px solid lightgrey; border-radius: 10px; padding: 20px;">
                    ${infoLine({value: "desideri uscire dal plesso?",title: `Il presidio non appartiene al ${swalTitle()} corrente`})}
                    ${infoLine({value: newClient?.label, title: "Cliente"})}
                    ${infoLine({value: newSite?.label, title: "Plesso"})}
                    ${infoLine({value: registerName, title: "Registro"})}
                    ${infoLine({value: devicePosition, title: "Posizione"})}
                    ${infoLine({value: deviceFloor, title: "Piano"})}
                    ${infoLine({value: deviceArea, title: "Zona"})}
                </div>
               `
                Swal.fire({
                    //icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sì, Esci!',
                    cancelButtonText: 'No',
                    html: htmlData
                  }).then((result) => {
                    if (result.isConfirmed) {
                        setClient(newClient)
                        if(newSite?._id){
                            setSite({...newSite, label: siteName(newSite), value: siteName(newSite)})
                        }
                        setRegister({...foundRegister, site: referenceDoc(foundRegister?.site?._id)})
                        setCurrentTemplate(registerTemplate)
                        setQrDevice(findDevice(foundRegister))
                    } 
                  })

            },
            onError: (error) => {
                console.log("RECEIVING ERROR FROM QR FETCH", {error, scannedQrUrl})
                errorAlert("NON E' STATO POSSIBILE COLLEGARSI AL SERVER PER TROVARE IL QR CODE IN ALTRI PLESSI")
            }
        
        })
        //errorAlert("QR CODE URL NON TROVATA")
       
    }
    
     //================================================= RETURN ================================================
     if (!user) 
        return <Loading/>; 

     if (!sUser && !user) 
        return <Loading/>; 

     if(user && !sUser){
        return (
        <div className="products-heading">
            <p>IL TUO UTENTE NON E' STATO TROVATO. CONTATTARE ASSISTENZA</p>
        </div>
        
        )
     }
     if(
        !isThereFailedDevicesQueryDocs() &&
        (clientsDataLoading || 
        subReasonsLoadingData ||
        registersAsTemplatesLoading ||
        nonConformitiesLoading ||
        customerProductsLoading || 
        subNonConformitiesLoading ||
        presidioModulesLoading ||
        templatesDataLoading ||
        customersUsersLoading)){
       return <Loading/>
     }
/*      if(!isThereFailedDevicesQueryDocs() &&
        (registersDataLoading ||
        offersDataLoading
        ) 
        && site){
       return <Loading/>
     } */
     if (!isThereFailedDevicesQueryDocs() && registerClientOrder &&  offersDataDataIdsLoading) {
        return <Loading/>
     }
     
     if( !isThereFailedDevicesQueryDocs() &&
        sitesDataLoading 
        && client){
        return <Loading/>
      }
    if( contractorsIds?.length>0 && !! sUser && !! user 
       //&& clientOrdersDataLoading
    ){
        return <Loading/>
    }

    if (loading)
        return <Loading/>;

    if (viewPdf) {
        return (
            <VisDiv rules={[]} className="products-heading" style={{flexDirection:"column", backgroundColor:"white"}}>
                <Selector
                    closeAllInfo={closeAllInfo}
                    clients={clients}
                    sites={sites}
                    //customers={customers}
                />
                <VisDiv rules={[client, !site]}>
                    <h3>{LDB(P, "accessSite")}</h3>
                </VisDiv>
                <VisDiv rules={[site]}>
                    <VisDiv>
                        <TrueFalseToggle
                            value={viewArchivedRegisters}
                            onClick={() => setViewArchivedRegisters(!viewArchivedRegisters)}
                            label={"VISUALIZZARE REGISTRI ARCHIVIATI"}
                        />
                    </VisDiv>
                    <SliderRegistri 
                        closeAllInfo={closeAllInfo} 
                        registers={registers?.filter((x)=>{
                            if(viewArchivedRegisters){
                                return x
                            }
                            else {
                                return x?.status !== "ARCHIVIATO" 
                            }
                        })} 
                        templates={registerTemplates} 
                        setLoading={setLoading}
                    />
                    <VisDiv rules={[register]}>
                        {pdfButton}
                            <TestButton copyId={register?._id} consoleData={{register, failedDevicesQueryDocs: failedDevicesQueryDocs, registers, isRegisterInRegisters}} buttonId={"qweqwekqpowek"} message='copy register Id' />
                        {pdfViewer}
                    </VisDiv>
                    <VisDiv style={{display:"flex", marginTop:"15px"}} rules={[site, !register]}>
                        <h3>{LDB(P, "accessRegister")}</h3>
                    </VisDiv>

                </VisDiv>

            </VisDiv>
        )}



    //#offlineUpdate
    if(
        networkStatus && 
        failedDevicesQueryDocs?.length>0 && 
        !bypassOffline  
        && clientUser(sUser)
    ) return  <OfflineUpdate data={{registersData: registers, closeAllInfo, }}/>
    
    //className= {!networkStatus ? "stop-scroll-refresh" : "products-heading"  }
    return (   
    <Fragment>
        <VisDiv rules={[indexPage=="HOME"]} className={networkStatus ? "products-heading" : "products-heading stop-scroll-refresh" }> 
            <TestButton onClick={testFunction} copyId={register?._id} consoleData={{selectedDevices, client, clients, clientsData, site, register, notFailedDocs:!isThereFailedDevicesQueryDocs(),  failedDevicesQueryDocs: failedDevicesQueryDocs, qrCheck, triggerSelectDevices, register, registers, currentTemplate, isRegisterInRegisters}} buttonId={"qoqiwdjoj9"} message='copy register Id' />
            <VisDiv style={{zIndex:1000,  cursor:"pointer", bottom:70, right:0,  position:"fixed"}} rules={[true]}>
                <div style={{backgroundColor:"white", backgroundColor:"lightgreen", padding:"20px", borderRadius:"50%", marginRight:"20px", boxShadow:"0px 0px 15px 0px rgba(0,0,0,0.30)"}}>
                    <ScanQrCode saveCode={saveQrCode}/>
                </div>
            </VisDiv>
            <VisDiv>
                <Selector
                    closeAllInfo={closeAllInfo}
                    clients={clients}
                    sites={sites?.filter?.((x)=>{
                        if(isWorksheet && Array.isArray(orderedSites)) {
                            //console.log("òoawejfaòoweifj", orderedSites)
                            return orderedSites?.some?.((y)=>y == x?._id) }
                        return x
                    })}
                    //customers={customers}
                />
            </VisDiv>
            <VisDiv rules={[client, !site]}>
                <h3>{LDB(P, "accessSite")}</h3>
            </VisDiv>
            <VisDiv rules={[clientOrdersData?.length > 1 && isWorksheet]} >
                <FieldDropdown
                    //isSearchable="isSearchable"
                    //placeHolder={"ASSEGNA NON CONFORMITA'"}
                    options={orderOptions}
                    initialValue={registerClientOrder}
                    onChange={(value) => { 
                        setRegisterClientOrder(value)
                    }}
                />
            </VisDiv>
            <VisDiv rules={[site, client]}>
                <VisDiv className='edit-button-container' style={{marginBottom:"28px", }} rules={[site, clientUser(sUser)]}>
                    <button type='button' className='pdf-button' style={{display:"flex", alignItems:"center", backgroundColor:"blue"}} onClick={()=>infoToggle()}>
                        <FiInfo            
                        size={18}
                        color={"white"}
                        />
                        <div style={{color:"white", marginLeft:"5px"}}>
                             INFORMAZIONI PLESSO
                        </div>
                       
                    </button>
                </VisDiv>
                <VisDiv className={"selector"} style={{marginBottom:"58px"}} rules={[viewInfo]}>
                    <SiteInfo setLoading={setLoading} site={site} setViewInfo={setViewInfo} devices={devices} deviceNonConformities={deviceNonConformities}/>
                </VisDiv>
                <VisDiv rules={[clientUser(sUser), registers?.some?.((x)=>x?.status == "ARCHIVIATO")]}>
                    <TrueFalseToggle
                        value={viewArchivedRegisters}
                        onClick={() => setViewArchivedRegisters(!viewArchivedRegisters)}
                        label={"VISUALIZZARE REGISTRI ARCHIVIATI"}
                    />
                </VisDiv>
                <SliderRegistri 
                    registersAsTemplates={registersAsTemplates}
                    showArchived={true}
                    hideTemplates={isWorksheet} 
                    closeAllInfo={closeAllInfo} 
                    registers={registers?.filter?.((x)=>{
                        if(isWorksheet && Array.isArray(orderedRegisters)) {
                            //console.log("òoawejfaòoweifj", newOrderedRegisters?.length)
                            return orderedRegisters?.some?.((y)=>y == x?._id) }

                        else if(!viewArchivedRegisters){ 
                            return x?.status !== "ARCHIVIATO" 
                        } else {
                             return x
                        }
                       
                    })} 
                    templates={registerTemplates} 
                    setLoading={setLoading}
                />
            </VisDiv>
            <VisDiv style={{display:"flex", marginTop:"15px"}} rules={[site, !register, registers?.length>0]}>
                <h3>{LDB(P, "accessRegister")}</h3>
            </VisDiv>
            <VisDiv rules={[site, registers?.length < 1]}>
                <h3>{LDB(P, "noRegisters")}</h3>
            </VisDiv>
            <VisDiv style={{display:"flex", alignItems:"center", justifyContent:"flex-end", marginRight:"10px", marginBottom:"5px"}} rules={[site, client]}>
                <VisDiv rules={[screenSizeDesktop, register]}>
                    <button className={mobileView ? 'view-button' :'not-view-button'}  onClick={()=>setMobileView(!mobileView)}>
                        {!mobileView ? LDB(P,"mobileView") : LDB(P,"desktopView")}
                    </button>
                </VisDiv>
                <VisDiv className='edit-button-container' style={{marginLeft:"12px", marginTop:"12px"}} rules={[!isWorksheet, networkStatus, register, facilityClient(client, sUser), clientUser(sUser)]}>
                    <button type='button' className='round-back-button' style={{backgroundColor:"red"}} onClick={()=>editingToggle()}>
                        <FiEdit             
                        size={15}
                        color={"white"}/>
                    </button>
                </VisDiv>

                <VisDiv className='edit-button-container' style={{marginLeft:"12px", marginTop:"12px"}} rules={[site, register, clientUser(sUser)]}>
                    <button type='button' className='round-back-button' style={{backgroundColor:"green"}} onClick={()=>registerInfoToggle()}>
                        <TbReportAnalytics            
                        size={20}
                        color={"white"}/>
                    </button>
                </VisDiv>
                <VisDiv className='edit-button-container' style={{marginLeft:"12px", marginTop:"12px"}} rules={[site, register, clientUser(sUser)]}>
                    <CheckIcon status={triggerSelectDevices} onClick={()=>setTriggerSelectedRegisters(!triggerSelectDevices)}/> 
                </VisDiv>
            </VisDiv>

            <VisDiv style={{marginBottom:"28px"}} className={"selector"} rules={[registerInfo]}>
                <RegisterInfo setRegisterInfo={setRegisterInfo} registerTemplate = {currentTemplate} register={register} devices={registerDevices} deviceNonConformities={deviceNonConformities}/>
            </VisDiv>
            <VisDiv style={{marginBottom:"28px"}} className={"selector"}  rules={[editRegister, register]}>
                <EditRegisters updateRegister={updateRegister} triggerSelectDevices={triggerSelectDevicesFn} setSelectedDevices={setSelectedDevices} selectedDevices={selectedDevices} setEditRegister={setEditRegister} sites={sites} registers={registers} queryName={['registers', site]}/>
            </VisDiv>
            <VisDiv rules={[!editRegister, register, isThereArchivedDevices, clientUser(sUser)]}>
                <TrueFalseToggle
                    value={viewArchivedDevices}
                    onClick={()=>setViewArchivedDevices(!viewArchivedDevices)}
                    label={"VISUALIZZA PRESIDI ARCHIVIATI"}
                />
            </VisDiv>
            <VisDiv rules={[!editRegister, register, clientUser(sUser)]}>
                <TrueFalseToggle
                    value={viewNonCheckedDevices}
                    onClick={()=>setViewNonCheckedDevices(!viewNonCheckedDevices)}
                    label={"VISUALIZZA PRESIDI NON CONTROLLATI"}
                />
            </VisDiv>
            <VisDiv style={{marginTop:"10px"}} rules={[!editRegister, register, isWorksheet]}>
                <TrueFalseToggle
                    value={viewAllDevices}
                    onClick={()=>setViewAllDevices(!viewAllDevices)}
                    label={"VISUALIZZA TUTTI I PRESIDI"}
                />
            </VisDiv>
            <VisDiv rules={[site, currentTemplate, registers]}>
                                        <VisDiv onClick={scrollToBottom} style={{cursor:"pointer"}} className={"selector-button-container"}>
                            <IoIosArrowDropdown size={25}/>
                            <p>{LDB(P, "bottomPage")}</p>
                        </VisDiv> 
                <VisDiv rules={[screenSizeDesktop, client, site, register, !mobileView]}>
                    <DesktopRegisterHeader 
                        headerData={headerDataPdf} 
                        pdfButton={pdfButton} 
                        registerNonConformities={NONCONF_REGISTRO}
                    />
                    { tableData && <RegisterTable devices={registerDevices} tableData={tableData}/> }   
                </VisDiv>
                <VisDiv rules={[!screenSizeDesktop || mobileView, client, site]} className='titolo-registro'>
                    <VisDiv rules={[register]}>                     
                        <VisDiv style={{marginTop:"10px"}} rules={[site]}>
                            <p>{site?.label}</p>
                            <p>{siteAddress(site)}</p>
                        </VisDiv>
                        <VisDiv rules={[currentTemplate?.icon]}>                                  
                            <TitleWithIcon
                            icon={currentTemplate?.icon}
                            title={currentTemplate?.family}
                            />
                        </VisDiv>
                        <div style={{marginBottom:"10px"}}>
                            <h4>{register?.registerName}</h4>
                        </div>
                        <p>{currentTemplate?.description}</p>
                        <VisDiv style={{marginTop:"10px", color:"red"}} rules={[register?.notInMaintenance]}>
                            <h2>REGISTRO NON IN MANUTENZIONE</h2>
                        </VisDiv>
                        <VisDiv style={{marginTop:"10px", color:"red"}} rules={[register?.status == "ARCHIVIATO"]}>
                            <h2>REGISTRO ARCHIVIATO</h2>
                        </VisDiv>
                        <VisDiv rules={[lastLog()]} style={{display:"flex", justifyContent:"center", marginTop:"10px"}}>
                            <UserIcon
                                //sPicture={sUser.image}
                                bypassCurrentUser={true}
                                size={40}
                                name
                                dateText={LDB("device", "lastCheck")}
                                date={lastLog()?.date}
                                otherUser={lastLog()?.postedBy}                   
                            />
                        </VisDiv>
                        <div style={{display:"flex", justifyContent:"center", alignItems:"center"}}>                               
                            {NONCONF_REGISTRO}
                        </div>                 
                        {devices && (!Array.isArray(registerDevices) ? [] : 
                            registerDevices
                            ?.filter?.((x)=>{
                                if(isWorksheet) {
                                    //console.log("lhluhliuh")
                                    if(viewAllDevices) return x
                                    return orderedDevices?.some?.((y)=>y == x?._id) 
                                }
                                return x
                            })
                            ?.sort((a,b)=> sortDevices(a,b,sortDevicesBy))
                            ?.map?.((device)=>{
                                const findTemplateDevice = !Array.isArray(presidioModulesData) ? undefined : presidioModulesData?.find((x)=>x?._id == device?.templateDevice?._ref)
                                const deviceWithLabel = {
                                    ...device,
                                    label: findTemplateDevice ? findTemplateDevice?.label : device?.label
                                }
                                return (
                                <div style={{display:"flex", alignItems:"center"}} key={device?._id}>
                                    <VisDiv style={{marginRight:"10px"}} rules={[triggerSelectDevices]}>
                                        <CheckIcon
                                            size={35}
                                            status = {selectedDevices?.some?.((x)=>x?._id == device?._id)}
                                            onClick={(e)=>{
                                                e?.stopPropagation?.();
                                                if(selectedDevices?.some?.((x)=>x?._id == device?._id)) setSelectedDevices(selectedDevices?.filter?.((x)=>x?._id != device?._id))
                                                else setSelectedDevices([...selectedDevices, device])
                                            }}
                                        />
                                    </VisDiv>
                                    <DevicePin
                                        device={deviceWithLabel}
                                        customerProducts={customerProductsData}
                                        replaceDevice={throttledReplaceDevice}
                                        updateRegister={updateRegister}
                                        offlineFn={offlineFn}
                                        //networkStatus={networkStatus}
                                        subNonConformities = {subNonConformitiesData}
                                        viewAllDevices = {viewAllDevices}
                                        deviceOrderedFields = {orderedOfferFields?.filter?.((x)=>x?.deviceId == device?._id)}
                                    />
                                </div>
                            )})
                        )
                        }
                    </VisDiv>
{/*                     <VisDiv rules={[tab=="WORKSHEET"]}>
                        <Worksheet/>
                    </VisDiv> */}
                </VisDiv>
                <VisDiv className="bottom-buttons" rules={[client, site, register, !isWorksheet, facilityClient(client, sUser), clientUser(sUser) ]} >
                    <AddButton
                        onClick={(e)=>addNewDevice(e)}
                        label = {LDB(P, "addAsset")}
                    />
                    <VisDiv rules={[networkStatus, false]} className='bottom-button'>
                        <button type="button" style={{backgroundColor: "red"}} className="btn" onClick={()=>archiveRegister()}>{LDB(P, "archiveRegister")}</button>
                    </VisDiv>

                </VisDiv>
                    <VisDiv onClick={scrollToTop} className={"selector-button-container"} style={{ alignItems:"right", cursor:"pointer"}}>
                        <IoIosArrowDropup size={25}/>
                        <p>Torna in alto</p>
                    </VisDiv> 
                <div style={{height:"80px"}}></div>
            </VisDiv>      
{/*             <VisDiv rules={[(!screenSizeDesktop || mobileView), client, site, clientUser(sUser)]}>
                <BottomMobileMenu
                    clickRegister={clickRegister}
                    clickWorksheet={clickWorksheet}
                    isWorksheet={isWorksheet}
                />
            </VisDiv> */}
        </VisDiv>
        <VisDiv rules={[indexPage=="DEVICE"]}> 
            <AddNewDevice 
                replaceDevice={throttledReplaceDevice} 
                //addToArray={addToArray} 
                qrCheck={qrCheck}
                setQrCheck={setQrCheck}
                updateRegister={updateRegister} 
                offlineFn={offlineFn} 
                device={currentDevice} 
                register={register}
            />
        </VisDiv>
    </Fragment>
    )
};

export default Home;
